"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[451,749],{

/***/ 3749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BTCValueCard": function() { return /* binding */ BTCValueCard; },
/* harmony export */   "BlogCard": function() { return /* binding */ BlogCard; },
/* harmony export */   "CalculatorCard": function() { return /* binding */ CalculatorCard; },
/* harmony export */   "GraphCard": function() { return /* binding */ GraphCard; },
/* harmony export */   "ImageBGCard": function() { return /* binding */ ImageBGCard; },
/* harmony export */   "LatestBlogCard": function() { return /* binding */ LatestBlogCard; },
/* harmony export */   "OutputCard": function() { return /* binding */ OutputCard; },
/* harmony export */   "WarningCard": function() { return /* binding */ WarningCard; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71383);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19010);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42997);



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;


 // TODO: green/red text

var BTCValueCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  box-shadow: ", ";\n  width: 100%;\n  min-width: 25rem;\n  align-items: center;\n  justify-content: space-between;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 0 2rem;\n  background: ", ";\n  @media screen and (max-width: ", ") {\n    flex: 1;\n  }\n  @media screen and (max-width: ", ") {\n    height: 100px;\n  }\n  min-height: 100px;\n  height: 100%;\n  box-sizing: border-box;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.shadow;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.glassEffect.blur;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.glassEffect.blur;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.glassBackground;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.lg.maxWidth;
});
var CalculatorCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  box-shadow: ", ";\n  flex-direction: column;\n  align-items: center;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 1rem;\n  background: ", ";\n  box-sizing: border-box;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.shadow;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.glassEffect.blur;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.glassEffect.blur;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.glassBackground;
});
var GraphCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  overflow: hidden;\n  box-shadow: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 1rem;\n  background: ", ";\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  .recharts-wrapper > svg.recharts-surface {\n    margin-top: 15px;\n  }\n  @media screen and (max-width: ", ") {\n    .recharts-wrapper > svg.recharts-surface {\n      margin-top: 25px;\n    }\n  }\n\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.shadow;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.glassEffect.blur;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.glassEffect.blur;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.glassBackground;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.breakpoints.sm.maxWidth;
});
var OutputCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-shadow: ", ";\n  max-height: 8rem;\n  min-width: 20rem;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 1.5rem 1rem;\n  background: ", ";\n\n  @media screen and (max-width: ", ") {\n    margin: ", ";\n  }\n  box-sizing: border-box;\n"])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.shadow;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.glassEffect.blur;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.glassEffect.blur;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.glassBackground;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.breakpoints.lg.minWidth;
}, function (_ref25) {
  var $margin = _ref25.$margin;
  return $margin ? $margin : 'initial';
});
var LatestBlogCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a */ .ZP.a(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: flex-end;\n  position: relative;\n  min-height: 100%;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 0;\n  background: ", ";\n  overflow: hidden;\n\n  text-decoration: none;\n\n  @media screen and (max-width: ", ") {\n    margin: ", ";\n  }\n  box-sizing: border-box;\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.glassEffect.blur;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.glassEffect.blur;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.glassBackground;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.breakpoints.lg.minWidth;
}, function (_ref31) {
  var $margin = _ref31.$margin;
  return $margin ? $margin : 'initial';
});
var WarningCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  background: ", ";\n  padding: 1rem;\n  color: black;\n  border-radius: 5px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  justify-content: space-between;\n\n  > p {\n    margin: 0;\n    font-weight: bold;\n  }\n"])), function (_ref32) {
  var theme = _ref32.theme;
  return theme.colors.secondaryGradient;
});
var ImageBGCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(function (_ref33) {
  var _ref34;

  var _ref33$theme = _ref33.theme,
      colors = _ref33$theme.colors,
      glassEffect = _ref33$theme.glassEffect,
      breakpoints = _ref33$theme.breakpoints,
      $img = _ref33.$img;
  return _ref34 = {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    width: '100%',
    height: '100%',
    borderRadius: glassEffect.borderRadius,
    transition: 'box-shadow 0.56s ease-in-out',
    backgroundColor: colors.cardBackground,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundImage: "url(".concat($img, ")")
  }, (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref34, '&:hover', {
    cursor: 'pointer',
    boxShadow: '0 24px 38px 3px rgba(0,0,0,0.14), 0 9px 46px 8px rgba(0,0,0,0.12), 0 11px 15px -7px rgba(0,0,0,0.2)'
  }), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref34, "@media screen and (max-width: ".concat(breakpoints.sm.maxWidth, ")"), {
    minHeight: '20rem'
  }), _ref34;
});
var BlogCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  box-shadow: ", ";\n  width: 100%;\n  max-width: 33rem;\n  min-width: 33rem;\n  max-height: 45rem;\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  border-radius: 5px;\n  padding: 2rem;\n  gap: 2rem;\n  cursor: pointer;\n  @media screen and (max-width: ", ") {\n    max-width: 100%;\n  }\n"])), function (_ref35) {
  var theme = _ref35.theme;
  return theme.colors.shadow;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.colors.glassBackground;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.breakpoints.sm.maxWidth;
});

/***/ }),

/***/ 9451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ outputs_graphs; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/recharts/es6/chart/BarChart.js + 28 modules
var BarChart = __webpack_require__(84328);
// EXTERNAL MODULE: ./node_modules/recharts/es6/component/Legend.js + 11 modules
var Legend = __webpack_require__(44141);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(3023);
// EXTERNAL MODULE: ./node_modules/recharts/es6/shape/Rectangle.js
var Rectangle = __webpack_require__(13481);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/Bar.js + 3 modules
var Bar = __webpack_require__(90605);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(75358);
// EXTERNAL MODULE: ./node_modules/recharts/es6/component/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(14888);
// EXTERNAL MODULE: ./utils/currency.js
var utils_currency = __webpack_require__(92442);
// EXTERNAL MODULE: ./node_modules/atomic-layout/lib/esm/index.js
var esm = __webpack_require__(19010);
// EXTERNAL MODULE: ./components/atoms/Cards.js
var Cards = __webpack_require__(3749);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(42997);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/AspectRatioBox.js


var _templateObject, _templateObject2;



var AspectRatioBoxOuter = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    overflow: visible;\n    height: 0;\n    padding-top: ", "%;\n    position: relative;\n    width: 100%;\n    max-width: calc(100vw - 2rem);\n    box-sizing: border-box;\n    @media screen and (max-width: 1080px) {\n      margin-bottom: 20px;\n    }\n"])), function (_ref) {
  var _ref$$aspectWidth = _ref.$aspectWidth,
      $aspectWidth = _ref$$aspectWidth === void 0 ? 1 : _ref$$aspectWidth,
      _ref$$aspectHeight = _ref.$aspectHeight,
      $aspectHeight = _ref$$aspectHeight === void 0 ? 1 : _ref$$aspectHeight;
  return $aspectHeight / $aspectWidth * 100;
});
var AspectRatioBoxInner = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n"])));
/**
 * <AspectRatioBox $aspectWidth={1920} $aspectHeight={1080} />
 */

var AspectRatioBox = function AspectRatioBox(_ref2) {
  var $aspectWidth = _ref2.$aspectWidth,
      $aspectHeight = _ref2.$aspectHeight,
      children = _ref2.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AspectRatioBoxOuter, {
    $aspectWidth: $aspectWidth,
    $aspectHeight: $aspectHeight,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(AspectRatioBoxInner, {
      children: children
    })
  });
};

/* harmony default export */ var atoms_AspectRatioBox = (AspectRatioBox);
// EXTERNAL MODULE: ./node_modules/decimal.js/decimal.js
var decimal = __webpack_require__(93776);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/atoms/Switch.js


var Switch_templateObject, Switch_templateObject2, _templateObject3, _templateObject4, _templateObject5;




var switchWidth = 120;
var OnOffSwitch = styled_components_browser_esm/* default.div */.ZP.div(Switch_templateObject || (Switch_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  width: ", "px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n"])), switchWidth);
var OnOffSwitchCheckbox = styled_components_browser_esm/* default.input */.ZP.input(Switch_templateObject2 || (Switch_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n\n  &:checked + label + span {\n    margin-left: 0;\n  }\n\n  &:checked + label,\n  span:last-child {\n    right: 0px;\n  }\n"])));
var OnOffSwitchLabel = styled_components_browser_esm/* default.label */.ZP.label(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  overflow: hidden;\n  cursor: pointer;\n  ", ";\n  -webkit-border-radius: 50px;\n  -khtml-border-radius: 50px;\n  -moz-border-radius: 50px;\n  border-radius: 50px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.glassEffect.border;
});
var OnOffSwitchInner = styled_components_browser_esm/* default.span */.ZP.span(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  width: 200%;\n  margin-left: ", ";\n  transition: margin 0.3s ease-in 0s;\n\n  &:before,\n  &:after {\n    display: block;\n    float: left;\n    width: 50%;\n    height: 20px;\n    padding: 0;\n    line-height: 20px;\n    font-size: 12px;\n    color: white;\n    box-sizing: border-box;\n    -webkit-border-radius: 50px;\n    -khtml-border-radius: 50px;\n    -moz-border-radius: 50px;\n    border-radius: 50px;\n  }\n\n  &:before {\n    content: attr(data-before-content);\n    padding-left: 10px;\n    backdrop-filter: blur(", ");\n    -webkit-backdrop-filter: blur(", ");\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:after {\n    content: attr(data-after-content);\n    padding-right: 10px;\n    backdrop-filter: blur(", ");\n    -webkit-backdrop-filter: blur(", ");\n    background-color: ", ";\n    color: ", ";\n    text-align: right;\n  }\n"])), function (_ref2) {
  var $checked = _ref2.$checked;
  return $checked ? 0 : '-100%';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.glassEffect.blur;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.glassEffect.blur;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.switchBackground;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.text;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.glassEffect.blur;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.glassEffect.blur;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.switchBackground;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.text;
});
var OnOffSwitchSwitch = styled_components_browser_esm/* default.span */.ZP.span(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: block;\n  width: 20px;\n  height: 20px;\n  margin: -1px;\n  background: ", ";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: ", ";\n  -webkit-border-radius: 50px;\n  -khtml-border-radius: 50px;\n  -moz-border-radius: 50px;\n  border-radius: 50px;\n  transition: all 0.3s ease-in 0s;\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primary;
}, function (_ref12) {
  var $checked = _ref12.$checked;
  return $checked ? 0 : "".concat(switchWidth - 20, "px");
});
var Switch = function Switch(_ref13) {
  var id = _ref13.id,
      leftLabel = _ref13.leftLabel,
      rightLabel = _ref13.rightLabel,
      onChange = _ref13.onChange,
      checked = _ref13.checked;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OnOffSwitch, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OnOffSwitchCheckbox, {
      type: "checkbox",
      id: id,
      onChange: onChange,
      checked: checked
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OnOffSwitchLabel, {
      htmlFor: id,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OnOffSwitchInner, {
        $checked: checked,
        "data-before-content": rightLabel,
        "data-after-content": leftLabel
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OnOffSwitchSwitch, {
        $checked: checked
      })]
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 29 modules
var format = __webpack_require__(18813);
// EXTERNAL MODULE: ./utils/resampling.ts
var resampling = __webpack_require__(27711);
// EXTERNAL MODULE: ./components/content/calculator/calculationContext.js
var calculationContext = __webpack_require__(93138);
// EXTERNAL MODULE: ./node_modules/react-resize-detector/build/index.esm.js
var index_esm = __webpack_require__(99612);
// EXTERNAL MODULE: ./utils/useTheme.js
var useTheme = __webpack_require__(58740);
;// CONCATENATED MODULE: ./utils/useIsMobile.js

function useIsMobile() {
  var _useState = (0,react.useState)(false),
      result = _useState[0],
      setResult = _useState[1];

  function check() {
    setResult(window.innerWidth < 600);
  }

  (0,react.useEffect)(function () {
    if (true) {
      check();
      window.addEventListener('resize', check);
    }

    return function () {
      check();
      window.removeEventListener('resize', check);
    };
  }, []);
  return result;
}
// EXTERNAL MODULE: ./utils/convertBtcSats.js
var convertBtcSats = __webpack_require__(72583);
;// CONCATENATED MODULE: ./components/content/calculator/outputs/graphs.js






var graphs_templateObject, graphs_templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var graphDateFormat = function graphDateFormat(_ref) {
  var sampleFrequency = _ref.sampleFrequency;
  return function (date) {
    if (sampleFrequency === 'DAILY' || sampleFrequency === 'WEEKLY') return (0,format/* default */.Z)(date, 'do MMM yy');
    if (sampleFrequency === 'YEARLY') return (0,format/* default */.Z)(date, 'yyyy');
    return (0,format/* default */.Z)(date, 'MMM yy');
  };
};

var CustomTick = function CustomTick(_ref2) {
  var theme = _ref2.theme,
      x = _ref2.x,
      y = _ref2.y,
      stroke = _ref2.stroke,
      payload = _ref2.payload,
      tickFormatter = _ref2.tickFormatter;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    transform: "translate(".concat(x, ",").concat(y, ")"),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("text", {
      x: 0,
      y: 0,
      dy: 16,
      textAnchor: "end",
      fill: theme.colors.text,
      transform: "rotate(-35)",
      children: tickFormatter(payload.value)
    })
  });
};

var EmptyText = styled_components_browser_esm/* default.p */.ZP.p(graphs_templateObject || (graphs_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: center;\n"])));

var ResizingBarChart = function ResizingBarChart(_ref3) {
  var props = (0,esm_extends/* default */.Z)({}, _ref3);

  var _useResizeDetector = (0,index_esm/* useResizeDetector */.NB)(),
      width = _useResizeDetector.width,
      height = _useResizeDetector.height,
      ref = _useResizeDetector.ref;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ref: ref,
    style: {
      height: '100%',
      width: '100%'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BarChart/* BarChart */.v, _objectSpread(_objectSpread({}, props), {}, {
      width: width,
      height: height
    }))
  });
};

var getMaxBarSize = function getMaxBarSize(numBars) {
  if (numBars < 8) return 100;
  if (numBars < 20) return 45;
  return 30;
};

var CustomLegend = function CustomLegend(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Legend/* Legend */.D, _objectSpread(_objectSpread({}, props), {}, {
    content: null,
    payload: (0,toConsumableArray/* default */.Z)(props.payload).reverse()
  }));
};

var BaseGraph = function BaseGraph(_ref4) {
  var data = _ref4.data,
      children = _ref4.children,
      sampleFrequency = _ref4.sampleFrequency,
      graphProps = _ref4.graphProps,
      _ref4$isFiat = _ref4.isFiat,
      isFiat = _ref4$isFiat === void 0 ? false : _ref4$isFiat;

  var _useCalculation = (0,calculationContext/* useCalculation */.C)(),
      startDate = _useCalculation.startDate,
      goalDate = _useCalculation.goalDate,
      isSatoshis = _useCalculation.isSatoshis;

  var theme = (0,useTheme/* default */.Z)();
  var legendAlign = (0,esm/* useResponsiveValue */.Vt)({
    xs: 'center'
  }, 'center');
  var btcPayload = [{
    id: 1,
    type: 'square',
    value: isSatoshis ? graphProps.cryptoGraphStackedSats : graphProps.cryptoGraphStackedBTC,
    color: theme.colors.secondaryGraphColor
  }, {
    id: 2,
    type: 'square',
    value: isSatoshis ? graphProps.cryptoGraphAccumulatedSats : graphProps.cryptoGraphAccumulatedBTC,
    color: theme.colors.primary
  }];
  var fiatPayload = [{
    id: 1,
    type: 'square',
    value: graphProps.fiatGraphRunningInvestmentGain,
    color: theme.colors.secondaryGraphColor
  }, {
    id: 2,
    type: 'square',
    value: graphProps.fiatGraphInvestmentGain,
    color: theme.colors.tertiaryGraphColor
  }];
  var legendPayload = isFiat ? fiatPayload : btcPayload;
  var hasCurrentStack = data[0] && data[0].currentStackedCrypto > 0;

  if (hasCurrentStack) {
    var fiatPayloadValue = graphProps.fiatGraphTotalInvested;
    var btcPayloadValue = isSatoshis ? graphProps.currentStackSats : graphProps.currentStackBTC;
    legendPayload.unshift({
      id: 3,
      type: 'square',
      value: isFiat ? fiatPayloadValue : btcPayloadValue,
      color: isFiat ? theme.colors.primary : theme.colors.graphColor
    });
  }

  return data.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ResizingBarChart, {
      data: data,
      barGap: 0,
      maxBarSize: getMaxBarSize(data.length),
      barCategoryGap: 6,
      margin: {
        top: 0,
        right: 0,
        left: 0,
        bottom: 43
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Legend/* Legend */.D, {
        payload: legendPayload,
        verticalAlign: "top",
        align: legendAlign,
        content: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomLegend, {}),
        wrapperStyle: {
          paddingLeft: '25px',
          paddingBottom: '10px'
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
        dataKey: "date",
        domain: [startDate, goalDate],
        tickFormatter: graphDateFormat({
          sampleFrequency: sampleFrequency
        }),
        tick: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomTick, {
          theme: theme
        }),
        interval: data.length > 24 ? 'preserveStartEnd' : 0,
        stroke: theme.colors.text
      }), children]
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Box */.xu, {
    flex: true,
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    maxHeightSmDown: 25,
    style: {
      boxSizing: 'border-box',
      width: '100%',
      height: '100%'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyText, {
      children: graphProps.fallbackText
    })
  });
};

var PositiveNegativeBar = function PositiveNegativeBar(theme, dataKey) {
  return function PositiveNegativeBar(props) {
    var fill = props.fill;
    var value = props[dataKey];
    var negativeFill = theme.colors.warningText;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Rectangle/* Rectangle */.A, _objectSpread(_objectSpread({}, props), {}, {
      fill: value >= 0 ? fill : negativeFill
    }));
  };
};

var roundToSigFigs = function roundToSigFigs(value, sigfigs) {
  return Number(Number(value).toPrecision(sigfigs));
};

var TooltipWrapper = styled_components_browser_esm/* default.div */.ZP.div(graphs_templateObject2 || (graphs_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0px;\n  padding: 10px;\n  background-color: rgb(238, 238, 238);\n  border: 1px solid rgb(204, 204, 204);\n  white-space: nowrap;\n  color: black;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  align-items: flex-start;\n  min-width: 100px;\n"])));
var TooltipSeries = styled_components_browser_esm/* default.p */.ZP.p(function (_ref5) {
  var theme = _ref5.theme,
      $color = _ref5.$color;
  return {
    display: 'block',
    color: theme.colors[$color || 'text'],
    margin: 0
  };
});

var FiatGraphTooltip = function FiatGraphTooltip(props) {
  var _props$payload$;

  var graphProps = props.graphProps,
      label = props.label,
      labelFormatter = props.labelFormatter,
      formatter = props.formatter;
  var payload = ((_props$payload$ = props.payload[0]) === null || _props$payload$ === void 0 ? void 0 : _props$payload$.payload) || {};
  var colourValueZero = 'textInverse';
  var colourValuePositive = 'tertiaryGraphColor';
  var colourValueNegative = 'warningText';
  var epsilon = 1e-14;
  var tooltipColour = Math.abs(payload.fiatGain) < epsilon ? colourValueZero : payload.fiatGain > 0 ? colourValuePositive : colourValueNegative;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      children: label && labelFormatter(label)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipSeries, {
      $color: "primary",
      children: [graphProps.fiatGraphTotalInvested, ":", ' ', formatter(payload.cumulativeInvestedFiat)]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipSeries, {
      $color: tooltipColour,
      children: [graphProps.fiatGraphInvestmentGain, ": ", formatter(payload.fiatGain)]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipSeries, {
      $color: payload.runningGain >= 0 ? 'secondaryGraphColor' : 'warningText',
      children: [graphProps.fiatGraphRunningInvestmentGain, ":", ' ', formatter(payload.runningGain)]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipSeries, {
      $color: "tooltipInverse",
      children: [graphProps.fiatGraphTotalValue, ":", ' ', formatter(payload.cumulativeTotalFiat)]
    })]
  });
};

var FiatGraph = function FiatGraph(_ref6) {
  var data = _ref6.data,
      graphProps = _ref6.graphProps,
      sampleFrequency = _ref6.sampleFrequency;

  var _useCalculation2 = (0,calculationContext/* useCalculation */.C)(),
      currency = _useCalculation2.currency;

  var theme = (0,useTheme/* default */.Z)();
  var dataMax = react.useMemo(function () {
    return Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(data.map(function (row) {
      return row.cumulativeTotalFiat;
    })));
  }, [data]);
  var topTick = roundToSigFigs(dataMax, 2);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BaseGraph, {
    data: data,
    sampleFrequency: sampleFrequency,
    graphProps: graphProps,
    isFiat: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Bar/* Bar */.$, {
      stackId: "1",
      name: graphProps.fiatGraphTotalInvested,
      dataKey: "cumulativeInvestedFiat",
      fill: theme.colors.primary
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Bar/* Bar */.$, {
      stackId: "1",
      name: graphProps.fiatGraphRunningInvestmentGain,
      dataKey: "runningGainMinusFiatGain",
      fill: theme.colors.secondaryGraphColor,
      shape: PositiveNegativeBar(theme, 'runningGainMinusFiatGain')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Bar/* Bar */.$, {
      stackId: "1",
      name: graphProps.fiatGraphInvestmentGain,
      dataKey: "fiatGain",
      fill: theme.colors.tertiaryGraphColor,
      shape: PositiveNegativeBar(theme, 'fiatGain')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
      domain: [0, topTick],
      tick: {
        width: 30
      },
      ticks: [topTick * 0.25, topTick * 0.5, topTick * 0.75, topTick],
      tickFormatter: function tickFormatter(value) {
        return (0,utils_currency/* toAbbreviatedCurrencyString */.jN)(value, currency, {
          maximumFractionDigits: 0,
          maximumSignificantDigits: 2
        });
      },
      stroke: theme.colors.text
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
      labelFormatter: graphDateFormat({
        sampleFrequency: sampleFrequency
      }),
      formatter: function formatter(value) {
        return (0,utils_currency/* toCurrencyString */.mr)(value, currency, {
          maximumFractionDigits: 2
        });
      },
      cursor: {
        fill: '#ffffff25'
      },
      labelStyle: {
        color: theme.colors.textInverse
      },
      contentStyle: {
        backgroundColor: theme.colors.text
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsx)(FiatGraphTooltip, {
        graphProps: graphProps
      })
    })]
  });
};

var CryptoGraphTooltip = function CryptoGraphTooltip(props) {
  var _props$payload$2;

  var _useCalculation3 = (0,calculationContext/* useCalculation */.C)(),
      isSatoshis = _useCalculation3.isSatoshis,
      currentStack = _useCalculation3.currentStack;

  var graphProps = props.graphProps,
      label = props.label,
      labelFormatter = props.labelFormatter,
      formatter = props.formatter;
  var payload = ((_props$payload$2 = props.payload[0]) === null || _props$payload$2 === void 0 ? void 0 : _props$payload$2.payload) || {};
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      children: label && labelFormatter(label)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipSeries, {
      $color: 'secondaryGraphColor',
      children: [isSatoshis ? graphProps.cryptoGraphStackedSats : graphProps.cryptoGraphStackedBTC, ": ", formatter(payload.stackedCrypto)]
    }), payload.totalMinusStackedCrypto ? /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipSeries, {
      $color: 'primary',
      children: [isSatoshis ? graphProps.cryptoGraphAccumulatedSats : graphProps.cryptoGraphAccumulatedBTC, ": ", formatter(payload.totalMinusStackedCrypto)]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), currentStack && currentStack !== '0' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipSeries, {
      $color: 'graphColor',
      children: [isSatoshis ? graphProps.currentStackSats : graphProps.currentStackBTC, ": ", (0,utils_currency/* numberWithCommas */.x6)(formatter(currentStack))]
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipSeries, {
      $color: 'tooltipInverse',
      children: [isSatoshis ? graphProps.cryptoGraphTotalSats : graphProps.cryptoGraphTotalBTC, ": ", formatter(payload.cumulativeTotalCrypto)]
    })]
  });
};

var CryptoGraph = function CryptoGraph(_ref7) {
  var data = _ref7.data,
      graphProps = _ref7.graphProps,
      sampleFrequency = _ref7.sampleFrequency;

  var _useCalculation4 = (0,calculationContext/* useCalculation */.C)(),
      isSatoshis = _useCalculation4.isSatoshis,
      currentStack = _useCalculation4.currentStack;

  currentStack = currentStack === '' || typeof currentStack === 'undefined' ? 0 : currentStack;
  var theme = (0,useTheme/* default */.Z)();
  var dataInSats = data.map(function (graphData) {
    return _objectSpread(_objectSpread({}, graphData), {}, {
      stackedCrypto: graphData.stackedCrypto * convertBtcSats/* SATOSHI_FACTOR */.Zx,
      cumulativeTotalCrypto: graphData.cumulativeTotalCrypto * convertBtcSats/* SATOSHI_FACTOR */.Zx
    });
  });
  var dataInUnit = isSatoshis ? dataInSats : data;
  var cryptoAdjustedData = react.useMemo(function () {
    return dataInUnit.map(function (point, index) {
      var totalMinusStackedCrypto = point.cumulativeTotalCrypto - point.stackedCrypto - currentStack;
      return _objectSpread(_objectSpread({}, point), {}, {
        currentStackedCrypto: currentStack,
        stackedCrypto: point.stackedCrypto,
        totalMinusStackedCrypto: totalMinusStackedCrypto >= 0 ? totalMinusStackedCrypto : 0
      });
    });
  }, [data]);
  var dataMax = react.useMemo(function () {
    return Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(dataInUnit.map(function (row) {
      return row.cumulativeTotalCrypto;
    })));
  }, [data]);
  var topTick = roundToSigFigs(dataMax, 2);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BaseGraph, {
    data: cryptoAdjustedData,
    sampleFrequency: sampleFrequency,
    graphProps: graphProps,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Bar/* Bar */.$, {
      stackId: "1",
      name: isSatoshis ? graphProps.currentStackSats : graphProps.currentStackBTC,
      dataKey: "currentStackedCrypto",
      fill: theme.colors.graphColor
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Bar/* Bar */.$, {
      stackId: "1",
      name: isSatoshis ? graphProps.cryptoGraphAccumulatedSats : graphProps.cryptoGraphAccumulatedBTC,
      dataKey: "totalMinusStackedCrypto",
      fill: theme.colors.primary
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Bar/* Bar */.$, {
      stackId: "1",
      name: isSatoshis ? graphProps.cryptoGraphStackedSats : graphProps.cryptoGraphStackedBTC,
      dataKey: "stackedCrypto",
      fill: theme.colors.secondaryGraphColor
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
      domain: [0, topTick],
      tick: {
        width: 30
      },
      ticks: [topTick * 0.25, topTick * 0.5, topTick * 0.75, topTick],
      tickFormatter: function tickFormatter(value) {
        return value ? (0,utils_currency/* formatWithLetters */.Hh)(value, {
          maximumFractionDigits: isSatoshis ? 0 : 3,
          minimunSignificantDigits: 2
        }) + '\n' + (0,utils_currency/* getUnitName */.ij)(value, isSatoshis) : '';
      },
      stroke: theme.colors.text
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
      labelFormatter: graphDateFormat({
        sampleFrequency: sampleFrequency
      }),
      formatter: function formatter(value) {
        return value ? value.toLocaleString(undefined, {
          maximumFractionDigits: isSatoshis ? 0 : 8
        }) : '';
      },
      cursor: {
        fill: '#ffffff25'
      },
      labelStyle: {
        color: theme.colors.tooltipInverse
      },
      contentStyle: {
        backgroundColor: theme.colors.text
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsx)(CryptoGraphTooltip, {
        graphProps: graphProps
      })
    })]
  });
};

var graphs = "\n    supplyLimitWarning  toggle\n    mobileWarning       mobileWarning\n    graph               graph\n";

var Graphs = function Graphs(_ref8) {
  var graphProps = _ref8.graphProps,
      graphToggleProps = _ref8.graphToggleProps;
  var isMobile = useIsMobile();

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      fiatToggle = _React$useState2[0],
      setFiatToggle = _React$useState2[1];

  var _useCalculation5 = (0,calculationContext/* useCalculation */.C)(),
      tableData = _useCalculation5.tableData,
      stackingFrequency = _useCalculation5.stackingFrequency,
      numTimePeriods = _useCalculation5.numTimePeriods,
      startDate = _useCalculation5.startDate,
      breachedLimit = _useCalculation5.breachedLimit;

  var _React$useMemo = react.useMemo(function () {
    var baseData = tableData;
    var sampleFrequency = stackingFrequency;

    if (stackingFrequency === 'DAILY' && numTimePeriods > 15 && numTimePeriods < 100) {
      sampleFrequency = 'WEEKLY';
      baseData = (0,resampling/* resample */.s)(tableData, 'DAILY', sampleFrequency, startDate);
    }

    if (stackingFrequency === 'DAILY' && numTimePeriods >= 100 && numTimePeriods < 1100) {
      sampleFrequency = 'MONTHLY';
      baseData = (0,resampling/* resample */.s)(tableData, 'DAILY', sampleFrequency, startDate);
    }

    if (stackingFrequency === 'DAILY' && numTimePeriods >= 1100) {
      sampleFrequency = 'YEARLY';
      baseData = (0,resampling/* resample */.s)(tableData, 'DAILY', sampleFrequency, startDate);
    }

    if (stackingFrequency === 'WEEKLY' && numTimePeriods > 15 && numTimePeriods < 155) {
      sampleFrequency = 'MONTHLY';
      baseData = (0,resampling/* resample */.s)(tableData, 'WEEKLY', sampleFrequency, startDate);
    }

    if (stackingFrequency === 'WEEKLY' && numTimePeriods >= 155) {
      sampleFrequency = 'YEARLY';
      baseData = (0,resampling/* resample */.s)(tableData, 'WEEKLY', sampleFrequency, startDate);
    }

    if (stackingFrequency === 'MONTHLY' && numTimePeriods >= 12 * 3) {
      sampleFrequency = 'YEARLY';
      baseData = (0,resampling/* resample */.s)(tableData, 'MONTHLY', sampleFrequency, startDate);
    }

    var graphData = (baseData || []).map(function (data) {
      var runningGain = data.cumulativeTotalFiat - data.cumulativeInvestedFiat;
      return _objectSpread(_objectSpread({}, data), {}, {
        runningGain: runningGain,
        runningGainMinusFiatGain: runningGain - data.fiatGain
      });
    });
    graphData = graphData.map(function (data) {
      return Object.fromEntries(Object.entries(data).map(function (_ref9) {
        var _ref10 = (0,slicedToArray/* default */.Z)(_ref9, 2),
            key = _ref10[0],
            value = _ref10[1];

        if (value instanceof decimal.Decimal) {
          return [key, value.toNumber()];
        }

        return [key, value];
      }));
    });
    return {
      graphData: graphData,
      sampleFrequency: sampleFrequency
    };
  }, [tableData, stackingFrequency, startDate, numTimePeriods]),
      graphData = _React$useMemo.graphData,
      sampleFrequency = _React$useMemo.sampleFrequency;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Cards.GraphCard, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Composition */.fS, {
      areas: graphs,
      gap: 1,
      width: "100%",
      flexGrow: 1,
      templateRows: "min-content auto",
      style: {
        boxSizing: 'border-box'
      },
      children: function children(Areas) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Areas.Toggle, {
            flex: true,
            justifyContent: "flex-end",
            alignItems: "center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Switch, {
              id: "crypto-fiat-graph-switch",
              leftLabel: (graphToggleProps === null || graphToggleProps === void 0 ? void 0 : graphToggleProps.cryptoLabel) || 'Bitcoin',
              rightLabel: (graphToggleProps === null || graphToggleProps === void 0 ? void 0 : graphToggleProps.fiatLabel) || 'Fiat',
              checked: fiatToggle,
              onChange: function onChange(e) {
                return setFiatToggle(e.target.checked);
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Areas.Graph, {
            flexDirection: "column",
            width: "113%",
            widthSm: "unset",
            marginLeft: "-15px",
            marginLeftSm: "-10px",
            marginLeftMd: "-5px",
            flex: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(atoms_AspectRatioBox, {
              style: {
                overflow: 'visible'
              },
              $aspectWidth: 16,
              $aspectHeight: isMobile ? 10 : 9,
              children: [!!fiatToggle && /*#__PURE__*/(0,jsx_runtime.jsx)(FiatGraph, {
                data: graphData,
                graphProps: graphProps,
                sampleFrequency: sampleFrequency
              }), !fiatToggle && /*#__PURE__*/(0,jsx_runtime.jsx)(CryptoGraph, {
                data: graphData,
                graphProps: graphProps,
                sampleFrequency: sampleFrequency
              })]
            })
          }), (graphData || []).length > 10 && /*#__PURE__*/(0,jsx_runtime.jsx)(Areas.MobileWarning, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Only */.ZI, {
              "for": "xs",
              flex: true,
              alignItems: "center",
              justifyContent: "center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: graphProps.smallScreenWarningText
              })
            })
          }), breachedLimit && /*#__PURE__*/(0,jsx_runtime.jsx)(Areas.SupplyLimitWarning, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cards.WarningCard, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: graphProps.overlimitWarningText
              })
            })
          })]
        });
      }
    })
  });
};

/* harmony default export */ var outputs_graphs = (Graphs);

/***/ }),

/***/ 27711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ResamplingUpError; },
/* harmony export */   "s": function() { return /* binding */ resample; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27812);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82262);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92777);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81531);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72179);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_wrapNativeSuper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46576);
/* harmony import */ var decimal_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93776);
/* harmony import */ var decimal_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(decimal_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var date_fns_isSameDay__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3151);
/* harmony import */ var date_fns_isSameMonth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49160);
/* harmony import */ var date_fns_isSameWeek__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67238);
/* harmony import */ var date_fns_isSameYear__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60792);
/* harmony import */ var date_fns_lastDayOfMonth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8230);
/* harmony import */ var date_fns_lastDayOfYear__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22546);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var ResamplingUpError = /*#__PURE__*/function (_Error) {
  (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ResamplingUpError, _Error);

  var _super = _createSuper(ResamplingUpError);

  function ResamplingUpError() {
    (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ResamplingUpError);

    return _super.apply(this, arguments);
  }

  return (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ResamplingUpError);
}( /*#__PURE__*/(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_wrapNativeSuper_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(Error));

var similarityFunction = function similarityFunction(toFrequency) {
  switch (toFrequency) {
    case "DAILY":
      return date_fns_isSameDay__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;

    case "WEEKLY":
      return date_fns_isSameWeek__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z;

    case "MONTHLY":
      return date_fns_isSameMonth__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z;

    case "YEARLY":
      return date_fns_isSameYear__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z;

    default:
      throw new Error("Unsuported toFrequency ".concat(toFrequency));
  }
};

var FREQUENCY_ORDER = ["DAILY", "WEEKLY", "MONTHLY", "YEARLY"];

var selectWithAccumulation = function selectWithAccumulation(data, accumulatorFields, acceptDate) {
  var _data$reduce = data.reduce(function (_ref, value, idx, dataArray) {
    var filteredArray = _ref.filteredArray,
        accumulators = _ref.accumulators;

    // accumulate values in the accumulators
    var _iterator = _createForOfIteratorHelper(accumulatorFields),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var fieldKey = _step.value;
        if (!accumulators[fieldKey]) accumulators[fieldKey] = new decimal_js__WEBPACK_IMPORTED_MODULE_3__.Decimal(0);
        accumulators[fieldKey] = accumulators[fieldKey].plus(value[fieldKey]);
      } // if this row is one we should retain,
      // write out the row with the accumulated values overwritten.

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (acceptDate(value, idx, dataArray)) {
      var newFilteredArray = [].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(filteredArray), [_objectSpread(_objectSpread({}, value), accumulators)]);
      accumulators = {}; // re-set the accumulators

      return {
        filteredArray: newFilteredArray,
        accumulators: accumulators
      };
    }

    return {
      filteredArray: filteredArray,
      accumulators: accumulators
    };
  }, {
    filteredArray: [],
    accumulators: {}
  }),
      filteredArray = _data$reduce.filteredArray;

  return filteredArray;
};

var resample = function resample(data, fromFrequency, toFrequency, startDate) {
  if (fromFrequency === toFrequency) return data; // no resampling required

  if (FREQUENCY_ORDER.indexOf(toFrequency) < FREQUENCY_ORDER.indexOf(fromFrequency)) {
    throw new ResamplingUpError("Trying to resample \"up\" from ".concat(fromFrequency, " to ").concat(toFrequency));
  }

  var isSame = similarityFunction(toFrequency);

  var acceptDate = function acceptDate(_ref2, idx, array) {
    var date = _ref2.date;
    if (idx === array.length - 1) return true; // last row? always return

    var endDate = array[array.length - 1].date;
    var nextDate = idx < array.length - 1 ? array[idx + 1].date : null;

    if (fromFrequency === "DAILY") {
      if (toFrequency === "MONTHLY") {
        // preserve the last day of the last month (the goal date) - but no other days in that month
        if ((0,date_fns_isSameMonth__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(date, endDate)) {
          if (date.getDate() === endDate.getDate()) return true;else return false;
        } // use the last day of the month for all the other months, especially the first


        if ((0,date_fns_isSameDay__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,date_fns_lastDayOfMonth__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(date), date)) return true;
        return false;
      }

      if (toFrequency === "WEEKLY") {
        if ((0,date_fns_isSameWeek__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(date, endDate) && date.getDate() !== endDate.getDate()) return false;
        if (date.getDay() === startDate.getDay()) return true;else return false;
      }
    }

    if (toFrequency === "YEARLY") {
      var lastDay = (0,date_fns_lastDayOfYear__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(date);

      if (fromFrequency === "DAILY" || fromFrequency === "MONTHLY") {
        if ((fromFrequency !== "DAILY" || (0,date_fns_isSameDay__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(lastDay, date)) && (0,date_fns_isSameMonth__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(lastDay, date)) return true;else return false;
      }

      if (fromFrequency === "WEEKLY") {
        if ((0,date_fns_isSameWeek__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(lastDay, date) || nextDate && !(0,date_fns_isSameYear__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(nextDate, lastDay)) return true;else return false;
      }
    } // by the time we get here, we're only dealing with WEEKLY -> MONTHLY


    if (!isSame(nextDate, date)) return true;
    return false;
  };

  return selectWithAccumulation(data, ['fiatGain', 'stackedCrypto'], acceptDate);
};

/***/ })

}]);